import {ServicesType} from "@feature/commons/types";

export const downloadBlob = (blob: Blob, name?: string) => {
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  if (!!name)
    link.download = name;
  link.click();
  link.remove();
}

export const serviceClassToType = (serviceClass: number): ServicesType => {
  switch (serviceClass) {
    case 0: return "design";
    case 1: return "quotation";
    case 2: return "service";
    default: throw new Error(`Unknown service class: ${serviceClass}`);
  }
}